import React from 'react';

import { Col, Row } from 'antd';


import Hints from '.';
import type { hintTypes } from '.';

export const NewProductHint = ({ type }: { type: hintTypes }) => {
  return (
    <div className='sticky top-16'>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Hints type={type} can />
        </Col>
        <Col span={24}>
          <Hints type={type} cant />
        </Col>
      </Row>
    </div>
  );
};
